/**
 * ### PROJECT_SUBJECT_OPTIONS
 *
 * @description
 * Available project subject options for target test demographics
 */
export default [
  {
    label: 'An Adult / Teen',
    value: 'adult',
  },
  {
    label: 'An Adult and / or Child (ages 5+)',
    value: 'child',
  },
  {
    label: 'An Adult with a Baby (ages 0-4)',
    value: 'baby',
  },
  {
    label: 'An Adult with a Pet',
    value: 'pet',
  },
] as const;
